import Survey from '@pages/survey.jsx'


export default function App() {
  return (<Survey />);
};
